module.exports = __webpack_public_path__ + "static/media/room-4.7accee53.jpeg";